<h1>Notification Area</h1>
<form [formGroup]="form" method="post" class="form">
  @if (nextButtonClicked) {
    <app-global-validation-message [formInput]="form"> </app-global-validation-message>
  }
  @if (!lodgementShapeGeoJsonControl?.valid) {
    <div class="alert alert-warning"><span
    class="fa fa-exclamation-triangle"></span> Map Lodgement drawing is not valid!</div>
  }
  <div class="alert alert-info">There are limits on the maximum area which can be cleared under this code.
    The limits will depend on the category or categories of vegetation selected and whether it is within the South East
    Queensland Regional Plan area,
    a Koala Priority area or a Koala Habitat area. Please ensure you have read the code and understand these limits.
  </div>
  <br />
  <ol class="questions">
    @if (requiresHarvestedWithin10YearsResponse) {
      <li class="group">
        <fieldset>
          <legend>
            <span class="label">Has this area been harvested in the past 10 years?</span>
            <abbr title="(required)" class="required">*</abbr>
          </legend>
          <ul class="choices">
            <li>
              <input type="radio" formControlName="isHarvestedWithinTenYears" value="Yes" name="isHarvestedWithinTenYears"
                id="isHarvestedWithinTenYears" />
                <label for="isHarvestedWithinTenYears">Yes - Fodder harvesting must NOT occur in a previously harvested area
                more than once every ten years.</label>
              </li>
              <li>
                <input type="radio" formControlName="isHarvestedWithinTenYears" value="No" name="isHarvestedWithinTenYears"
                  id="isNotHarvestedWithinTenYears" />
                  <label for="isNotHarvestedWithinTenYears">No</label>
                </li>
              </ul>
              @if (!isHarvestedWithinTenYearsValid) {
                <div>
                  <label>
                    @if (!isHarvestedWithinTenYearsControl?.value && nextButtonClicked) {
                      <div class="alert alert-warning">Please select
                      whether the area has been harvested in the past 10 years</div>
                    }
                    @if (isHarvestedWithinTenYearsControl?.value === 'Yes' && nextButtonClicked) {
                      <div class="alert alert-warning">You cannot notify
                      if fodder harvesting has occurred in the past 10 years</div>
                    }
                  </label>
                </div>
              }
            </fieldset>
          </li>
        }
        @if (requiresIsCoastalResponse) {
          <li class="group">
            <fieldset>
              <legend>
                <span class="label">Is the clearing area coastal or non-coastal?</span>
                <abbr title="(required)" class="required">*</abbr>
              </legend>
              <ul class="choices">
                <li>
                  <label><input type="radio" [value]=true formControlName="isCoastalResponse" /> Coastal</label>
                </li>
                <li>
                  <label><input type="radio" [value]=false formControlName="isCoastalResponse" /> Non-coastal</label>
                </li>
              </ul>
              @if (coastalResponseMessages.showFirebreakCoastalMessage) {
                <div class="alert alert-warning">Clearing to
                  establish firebreaks in Category B vegetation is exempt clearing works if the maximum width is 1 ½ times the
                  height of the tallest vegetation next to the infrastructure or 20 metres whichever is the greater. If you wish
                to clear a firebreak greater than this, you will need to apply for a development approval.</div>
              }
              @if (coastalResponseMessages.showThinningCoastalMessage) {
                <div class="alert alert-info">On lots less than
                  100 hectares, the maximum area which can be cleared is 10% of the total area of the Category B area on the
                  lot.
                  On lots greater than 100 hectares in coastal areas, the maximum area which can be cleared is either 10% total
                  area of Category B or the lot or 200 hectares whichever is the lesser.
                  To calculate the Category B area limits, refer to the Vegetation Management Property Report for your property.
                  Copies of these reports are available from the <a
                href='https://www.qld.gov.au/environment/land/vegetation/map-request'>Department’s website.</a></div>
              }
              @if (coastalResponseMessages.showThinningNonCoastalMessage) {
                <div class="alert alert-info">On lots less
                  than 100 hectares, the maximum area which can be cleared is 10% of the total area of the Category B area on
                  the lot.
                  On lots greater than 100 hectares in non-coastal areas, the maximum area which can be cleared is either 10% of
                  the total area of Category B area on the lot or 400 hectares whichever is the lesser.
                  To calculate the Category B area limits, refer to the Vegetation Management Property Report for your property.
                  Copies of these reports are available from the <a
                href='https://www.qld.gov.au/environment/land/vegetation/map-request'>Department’s website.</a></div>
              }
              @if (!isCostalResponsePresentValid && form.dirty && nextButtonClicked) {
                <div class="alert alert-warning">Please select whether the lot on plan is
                coastal or non-coastal.</div>
              }
            </fieldset>
          </li>
        }
        @if (requiresClearingAreaQuestion) {
          <div>
            <fieldset>
              <legend>
                <span class="label">Is the clearing located within any of the following areas:</span>
                <abbr title="(required)" class="required">*</abbr>
              </legend>
              <ul class="list-default">
                <li>an endangered regional ecosystem</li>
                <li>an of concern regional ecosystem</li>
                <li>an area of essential habitat</li>
                <li>a riparian protection zone</li>
                <li>an island of vegetation?</li>
              </ul>
              <ul class="choices">
                <li>
                  <label><input type="radio" formControlName="isInRestrictedClearingArea" [value]=true> Yes</label>
                </li>
                <li>
                  <label><input type="radio" formControlName="isInRestrictedClearingArea" [value]=false> No</label>
                </li>
              </ul>
              @if (isInRestrictedClearingAreaValid === false && form.dirty) {
                <div class="alert alert-warning">Clearing in this area is not permitted under the code.</div>
              }
            </fieldset>
          </div>
        }
        <li class="group">
          <fieldset>
            <legend>
              <span class="label">How do you want to provide the location of the area to be {{this.isNFPorFodder ?
              'harvested' : 'cleared' }}?</span>
              @if (!gpsPointsOptional) {
                <abbr title="(required)" class="required">*</abbr>
              }
            </legend>
            <ul class="choices">
              <li>
                <input type="radio" formControlName="howToProvide" id="howToProvide-gps" value="gps" (click)="resetArea()" />
                <label for="howToProvide-gps">
                  Specify clearing area using map
                </label>
              </li>
              <li>
                <input type="radio" formControlName="howToProvide" id="howToProvide-map" value="map" (click)="resetArea()" />
                <label for="howToProvide-map">
                  Attach a sketch or shape file(s)
                </label>
              </li>
              @if ((howToProvideControl?.value === null || howToProvideControl?.value === false) && form.dirty && nextButtonClicked) {
                <div class="alert alert-warning">Please select how you
                want to provide the shape of the area to be cleared</div>
              }
            </ul>
          </fieldset>
        </li>

        @if (!areaPresentValid && howToProvideControl?.value === 'map' && nextButtonClicked) {
          <div class="alert alert-warning">Area is required</div>
        }
        @if (isAreaWidthDirty && !isAreaWidthValid && howToProvideControl?.value === 'gps') {
          <div class="alert alert-warning">You must enter a width for the area being cleared!</div>
        }
        @if (showNotificationAreaLimitMessage && nextButtonClicked) {
          <div class="alert alert-warning" [innerHTML]="notificationAreaLimitMessage"></div>
        }
        @if (areaPresentValid && !areaRangeValid  && areaLimit.remainingAreaLimitInHectares <= 0 && nextButtonClicked) {
          <div class="alert alert-warning">
          The maximum area allowed for this lot on plan has already been exceeded</div>
        }
        @if (requiresExtractiveIndustryCatBMessage && nextButtonClicked) {
          <div class="alert alert-info">The maximum allowable area to be cleared
          under this code in a Category B area is 5 hectares.</div>
        }
        @if ((islodgmentinLotPlan$ | async) === false && nextButtonClicked) {
          <div class="alert alert-warning"><span
          class="fa fa-exclamation-triangle"></span> Area to clear should be within the specified lot and plan.</div>
        }
        @if (requiresAreaInHectares && howToProvideControl?.value === 'map') {
          <li class="group">
            <fieldset>
              <legend>
                <span class="label">How large is the area to be {{isNFPorFodder ? 'harvested' : 'cleared' }}?</span>
              </legend>
              <ol class="questions">
                <li class="required"
                  [ngClass]="{'invalid': !areaPresentValid || !areaRangeValid, 'required': !estimatedAreaOptional}">
                  <label for="areaInHectares">
                    <span class="label">Area in hectares</span>
                    @if (!estimatedAreaOptional) {
                      <abbr title="(required)" class="required">*</abbr>
                    }
                    <input type="number" min="0" step="any" formControlName="area" [required]="!estimatedAreaOptional"
                      name="areaInHectares" size="20" id="area" />
                    </label>
                  </li>
                </ol>
              </fieldset>
            </li>
          }
          @if (howToProvideControl?.value === 'gps' && gpsHasValueValid === false && form.dirty && nextButtonClicked) {
            <div class="alert alert-warning">Please provide a drawing using the Lodgement spatial map</div>
          }
          @if (howToProvideControl?.value === 'gps') {
            <li class="section">
              <label>
                <span class="label">Lot on Plan total area in hectares</span><input type="number" name="lotPlanAreaInHectares"
                size="20" id="lotPlanAreaInHectares" formControlName="lotOnPlanArea" readonly>
                <span class="label">Selected area in hectares</span><input type="number" name="areaInHectares" size="20"
                id="area" formControlName="area" readonly>
                @if (linearMapSelectionRequired) {
                  <span class="label">Width of selected area in meters</span>
                  }@if (linearMapSelectionRequired) {
                  <input type="number" name="areaWidth" size="20"
                    id="areaWidth" formControlName="areaWidth" (change)="updateWidth()">
                }
              </label>
              <br>
                @if (areAreasOverlapping$ | async) {
                  <div class="alert alert-warning"><span class="fa fa-exclamation-triangle"></span>
                Areas cannot overlap.</div>
              }
              <br>
                <fieldset>
                  <!-- Spatial data capture map component -->
                  <app-map [inputMapComponentModel]="mapComponentModel" (mapDataEvent)="handleMapDataEmitEvent($event)"></app-map>
                </fieldset>
              </li>
            }
            @if (howToProvideControl?.value === 'map') {
              <li class="section" >
                <label>
                  @if (!gpsPointsOptional) {
                    <abbr title="(required)" class="required">*</abbr>
                  }
                  <span class="label">Attach up to 5 map files</span>
                  <small>
                    We accept: DOC, DOCX, PDF, ODF, BMP, PNG, XLS or XLSX, ESRI shapefile (.ZIP, .RAR), MapInfo (.ZIP, .RAR),
                    .DXF, .KML, KMZ, TIFF, GeoTIFF, JPEG, GeoJPEG, Endas Imagine IMG format (BMP excluded), Arc Grid (.ZIP)
                  </small>
                  @if (!mapUploadValid && nextButtonClicked) {
                    <div class="alert alert-warning">A map upload is required</div>
                  }
                </label>
                <fieldset>
                  @if (!!mapError) {
                    <div class="alert alert-warning">
                      <h2>Error uploading map</h2>
                      <p>{{mapError}}</p>
                    </div>
                  }
                  @if (mapProvidedControl?.value) {
                    <div class="alert alert-success">
                      <h2><span class="fa fa-check-square"></span>Map provided</h2>
                      <ul>
                        @for (item of mapFileNames; track item; let i = $index) {
                          <li><strong>{{ item }}</strong> [<a
                        (click)="removeMapFile(item)">Remove</a>]
                      </li>
                    }
                  </ul>
                  <p><button (click)="removeAll()">Remove All maps</button></p>
                  <p>To replace the uploaded map, drop or select a different file below.</p>
                </div>
              }
              <br />
              <div class="center">
                <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="uploadOrDroppedFiles($event)"
                  (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"
                  accept={{validMapMimeType}} >
                  <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    Drag your A4 map here, or &nbsp;&nbsp;&nbsp;
                    <button type="button" (click)="openFileSelector()">Browse Files</button>
                  </ng-template>
                </ngx-file-drop>
              </div>
            </fieldset>
          </li>
        }
      </ol>
      <li class="footer">
        <ul class="actions">
          <li>
            <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" />
          </li>
          <li>
            <em><input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /></em>
          </li>
        </ul>
      </li>
      <ul class="actions">
        <li>
          <a href (click)="cancel()">Cancel</a>
        </li>
      </ul>
    </form>
